// EG-1599 Creative Preferences.
// The form's structure — section order, titles, questions, options and caps —
// comes from the server on every load. Nothing about it is declared here.

// YouTube's IFrame Player API. Loading it defines `window.YT`, which is the
// only way to drive an embedded player: read a playlist's queue, jump to a
// video, unmute one. A plain embed needs none of it.
export const YOUTUBE_IFRAME_API_URL = 'https://www.youtube.com/iframe_api';

export const STORAGE_KEY = 'eg_creative_preferences';

export const TEXT_MAX = 2000;

// The block kinds a display field's body parses into. `CARDS` is made at
// render time, when adjacent cards are grouped into one grid.
export const BLOCK = {
  PARAGRAPH: 'p',
  CARD: 'card',
  CARDS: 'cards',
  NOTE: 'note',
  HELP: 'help',
};
